var accordionButtons = jQuery('.accordion-controls li button');

function accordionToggle() {
  jQuery('.accordion-controls li button').on('click', function(e) {
    jQuerycontrol = jQuery(this);

    accordionContent = jQuerycontrol.attr('aria-controls');
    // checkOthers(jQuerycontrol[0]);

    isAriaExp = jQuerycontrol.attr('aria-expanded');
    newAriaExp = (isAriaExp == "false") ? "true" : "false";
    jQuerycontrol.attr('aria-expanded', newAriaExp);

    isAriaHid = jQuery('#' + accordionContent).attr('aria-hidden');
    if (isAriaHid == "true") {
      jQuery('#' + accordionContent).attr('aria-hidden', "false");
      jQuery('#' + accordionContent).css('display', 'block');
    } else {
      jQuery('#' + accordionContent).attr('aria-hidden', "true");
      jQuery('#' + accordionContent).css('display', 'none');
    }
  });
};

function checkOthers(elem) {
  for (var i=0; i<accordionButtons.length; i++) {
    if (accordionButtons[i] != elem) {
      if ((jQuery(accordionButtons[i]).attr('aria-expanded')) == 'true') {
        jQuery(accordionButtons[i]).attr('aria-expanded', 'false');
        content = jQuery(accordionButtons[i]).attr('aria-controls');
        jQuery('#' + content).attr('aria-hidden', 'true');
        jQuery('#' + content).css('display', 'none');
      }
    }
  }
};

accordionToggle();
